import React, { useEffect, useRef, useState } from 'react';
import { io } from 'socket.io-client';

const socket = io("https://webrtc.d-rosa.ai", {
  path: "/socket.io/",
  transports: ["websocket"],
  secure: true
});

function RosaRApp() {

  const localVideoRef = useRef(null);
  const remoteVideoRef = useRef(null);

const intervalRef = useRef(null);
  const relayStatesRef = useRef([]); // ? added ref


  const pcRef = useRef(null);
  const localStreamRef = useRef(null);

  const [room,setRoom]=useState("");
  const [joined,setJoined]=useState(false);

  const [initiator,setInitiator]=useState(false);

  const [audioEnabled,setAudioEnabled]=useState(true);
  const [videoEnabled,setVideoEnabled]=useState(true);

  const [screenSharing, setScreenSharing] = useState(false);
  const screenTrackRef = useRef(null);

  const [relayStates,setRelayStates]=
  useState(Array(8).fill(false));

  const [commandLog,setCommandLog]=
  useState([]);

  const [user]=useState(
      "user-"+Math.floor(
      Math.random()*10000
  ));

  const esp32IP="192.168.1.100";



 const cleanupPeer = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    if (pcRef.current) pcRef.current.close();
    pcRef.current = null;
    if (localStreamRef.current) {
      localStreamRef.current.getTracks().forEach(track => track.stop());
    }
    localStreamRef.current = null;
    screenTrackRef.current = null;
    setInitiator(false);
    setJoined(false);
    setRelayStates(Array(8).fill(false));
    setAudioEnabled(true);
    setVideoEnabled(true);
  };

  const updateRelayState = (relayNumber, state) => {
    setRelayStates(prev => {
      const updated = [...prev];
      updated[relayNumber - 1] = state;
      return updated;
    });
  };

  const streamRelayState = (label = "?? Streamed binary") => {
    if (pcRef.current?.dataChannel?.readyState === "open") {
      const binaryString = relayStatesRef.current.map(state => (state ? 1 : 0)).reverse().join("");
      const message = {
        type: "relay_stream",
        binary: binaryString
      };
      pcRef.current.dataChannel.send(JSON.stringify(message));
      setCommandLog(prev => [...prev, `${label}: ${binaryString}`]);
    }
  };

  const streamRelayBinaryContinuously = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      streamRelayState("?? Streamed binary (interval)");
    }, 1000);
  };





  const initializePeer=async()=>{

      try{

      const response=
      await fetch(
      "https://webrtc.d-rosa.ai/turn"
      );

      const config=
      await response.json();

      console.log(config);

      const pc=
      new RTCPeerConnection({

      iceServers:
      config.iceServers

      });

      pcRef.current=pc;

      return pc;

      }

      catch(err){

      console.log(
      "TURN fetch failed"
      );

      const pc=
      new RTCPeerConnection({

      iceServers:[

      {
      urls:
      "stun:stun.l.google.com:19302"
      }

      ]

      });

      pcRef.current=pc;

      return pc;

      }

  };



const setupDataChannel=(channel)=>{

channel.onopen=()=>{

console.log(
"Data channel open"
);

};

channel.onmessage=(event)=>{

try{

const data=
JSON.parse(
event.data
);

setCommandLog(
prev=>[
...prev,
JSON.stringify(data)
]
);

if(
data.type==="relay_binary"
){

const relayNum=
data.relay;

const action=
data.action;

const url=
`http://${esp32IP}/relay${relayNum}/${action}`;

window.open(
url,
'_blank'
);

setRelayStates(prev=>{

const updated=
[...prev];

updated[
relayNum-1
]=action==="on";

return updated;

});

}

}
catch(err){

console.log(err);

}

};

pcRef.current.dataChannel=
channel;

};



const startCall=async()=>{

if(!pcRef.current)
return;

try{

const channel=
pcRef.current
.createDataChannel(
"relayChannel"
);

setupDataChannel(
channel
);

const offer=
await pcRef.current
.createOffer();

await pcRef.current
.setLocalDescription(
offer
);

socket.emit(
"signal",
{
type:"offer",
offer,
room,
user
}
);

}
catch(err){

console.log(err);

}

};



const handleJoin=()=>{

if(room.trim()){

cleanupPeer();

socket.emit(
"join",
{
room,
user
});

setJoined(
true
);

}

};

  const handleEndCall = () => {
    cleanupPeer();
  };



const triggerRelay=(relay)=>{

const action=
relayStates[
relay-1
]
?"off":"on";


const url=
`http://${esp32IP}/relay${relay}/${action}`;

window.open(
url,
'_blank'
);


const updated=[
...relayStates
];

updated[
relay-1
]=action==="on";

setRelayStates(
updated
);


if(
pcRef.current
?.dataChannel
?.readyState
==="open"
){

pcRef.current
.dataChannel
.send(

JSON.stringify({

type:
"relay_binary",

relay,

action

})

);

}

};



const handleToggleAudio=()=>{

const track=
localStreamRef.current
?.getAudioTracks()[0];

if(track){

track.enabled=
!track.enabled;

setAudioEnabled(
track.enabled
);

}

};



const handleToggleVideo=()=>{

const track=
localStreamRef.current
?.getVideoTracks()[0];

if(track){

track.enabled=
!track.enabled;

setVideoEnabled(
track.enabled
);

}

};

  const handleShareScreen = async () => {
    if (!pcRef.current || !localStreamRef.current) return;

    if (!screenSharing) {
      try {
        const screenStream = await navigator.mediaDevices.getDisplayMedia({ video: true });
        const screenTrack = screenStream.getVideoTracks()[0];
        screenTrackRef.current = screenTrack;

        const sender = pcRef.current.getSenders().find(s => s.track.kind === "video");
        if (sender) sender.replaceTrack(screenTrack);

        screenTrack.onended = () => {
          handleStopShare();
        };

        setScreenSharing(true);
      } catch (err) {
        console.error("Screen share error:", err);
      }
    } else {
      handleStopShare();
    }
  };

  const handleStopShare = () => {
    const videoTrack = localStreamRef.current.getVideoTracks()[0];
    const sender = pcRef.current.getSenders().find(s => s.track.kind === "video");
    if (sender && videoTrack) sender.replaceTrack(videoTrack);
    screenTrackRef.current?.stop();
    setScreenSharing(false);
  };


useEffect(() => {

    if (!joined) return;

    let mounted = true;

    (async () => {

        const pc = await initializePeer();

        if (!mounted) return;

        const stream =
        await navigator.mediaDevices.getUserMedia({
            video: true,
            audio: true
        });

        localStreamRef.current = stream;

        if (localVideoRef.current) {
            localVideoRef.current.srcObject = stream;
        }

        stream.getTracks().forEach(track => {
            pc.addTrack(track, stream);
        });

        pc.ontrack = (event) => {

            const [stream] = event.streams;

            if (remoteVideoRef.current) {
                remoteVideoRef.current.srcObject = stream;
            };

        };

        pc.onicecandidate=(event)=>{

            if(event.candidate){

                socket.emit(
                "signal",
                {
                    type:"ice",
                    candidate:event.candidate,
                    room,
                    user
                });

            }

        };

        pc.ondatachannel=(event)=>{

            setupDataChannel(
                event.channel
            );

        };

        socket.on(
        "signal",
        async(data)=>{

            if(!pcRef.current)
                return;

            if(data.type==="offer"){

                await pcRef.current
                .setRemoteDescription(
                    new RTCSessionDescription(
                        data.offer
                    )
                );

                const answer=
                await pcRef.current
                .createAnswer();

                await pcRef.current
                .setLocalDescription(
                    answer
                );

                socket.emit(
                "signal",
                {
                    type:"answer",
                    answer,
                    room,
                    user
                });

            }

            else if(
            data.type==="answer"
            ){

                await pcRef.current
                .setRemoteDescription(
                    new RTCSessionDescription(
                        data.answer
                    )
                );

            }

            else if(
            data.type==="ice"
            ){

                await pcRef.current
                .addIceCandidate(
                    new RTCIceCandidate(
                        data.candidate
                    )
                );

            }

        });

        socket.on(
        "initiator",
        data=>{

            if(
            data.initiatorUser===user
            ){

                setInitiator(
                    true
                );

            }

        });

    })();

    return()=>{

        mounted=false;

        socket.off(
            "signal"
        );

        socket.off(
            "initiator"
        );

        cleanupPeer();

    };

}, [joined]);

useEffect(() => {
    if (joined && initiator) {
      setTimeout(() => startCall(), 1500);
    }
  }, [initiator]);

  return (
    <div style={{ padding: 20, backgroundColor: "#ffe0b2", minHeight: "100vh" }}>
      <h2 style={{ color: "#c2185b", textAlign: "center" }}>WebRTC + 8-Relay Control</h2>
      <p><b>User:</b> {user}</p>

      {!joined ? (
        <>
          <input placeholder="Enter room" value={room} onChange={e => setRoom(e.target.value)} />
          <button onClick={handleJoin} style={{ backgroundColor: "#1565c0", color: "white", marginLeft: 10 }}>Join Room</button>
        </>
      ) : (
        <>
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', marginBottom: 20 }}>
            <video ref={localVideoRef} autoPlay muted playsInline style={{ width: 320, border: '2px solid green' }} />
            <video ref={remoteVideoRef} autoPlay playsInline style={{ width: 320, border: '2px solid blue' }} />
          </div>

          <div style={{ display: 'flex', justifyContent: 'center', gap: 10, marginBottom: 20 }}>
            <button onClick={handleToggleAudio} style={{ backgroundColor: '#1565c0', color: 'white' }}>
              {audioEnabled ? 'Mute Audio' : 'Unmute Audio'}
            </button>
            <button onClick={handleToggleVideo} style={{ backgroundColor: '#1565c0', color: 'white' }}>
              {videoEnabled ? 'Turn Camera Off' : 'Turn Camera On'}
            </button>
            <button onClick={handleShareScreen} style={{ backgroundColor: '#1565c0', color: 'white' }}>
              {screenSharing ? 'Stop Sharing' : 'Share Screen'}
            </button>
            <button onClick={handleEndCall} style={{ backgroundColor: '#d32f2f', color: 'white' }}>
              End Call
            </button>
          </div>

          <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: 10 }}>
            {Array.from({ length: 8 }, (_, i) => (
              <button
                key={i}
                onClick={() => triggerRelay(i + 1)}
                style={{
                  padding: 10,
                  backgroundColor: relayStates[i] ? "#c8e6c9" : "#ffcdd2",
                  border: "1px solid #00796b",
                  width: 130
                }}>
                Relay {i + 1} ({(1 << (8 - i - 1)).toString(2).padStart(8, '0')})<br />
                {relayStates[i] ? "? ON" : "? OFF"}
              </button>
            ))}
          </div>

          <div style={{ marginTop: 30 }}>
            <h4>?? Command Log</h4>
            <div style={{ backgroundColor: "#f0f0f0", padding: 10, maxHeight: 200, overflowY: "scroll", border: "1px solid #ccc" }}>
              {commandLog.map((log, idx) => <div key={idx}>{log}</div>)}
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default RosaRApp;